import React from 'react';
import PropTypes from 'prop-types';

const IconWithAction = ({ BackgroundIcon, ForegroundIcon, top, bottom, left, right, height, width, background, style, roundBorder }) => {
  const h = height || width;
  const compStyle = Object.assign({ width: '24px', height: '24px', position: 'relative' }, style);
  return (
    <div
      className="MuiSvgIcon-root grbrsm-svgicon"
      style={compStyle}
    >
      <BackgroundIcon />
      <ForegroundIcon
        className="grbrsm-add-icon"
        style={{
          position: 'absolute',
          left: left !== undefined ? `${left}px` : undefined,
          right: right !== undefined ? `${right}px` : undefined,
          bottom: bottom !== undefined ? `${bottom}px` : undefined,
          top: top !== undefined ? `${top}px` : undefined,
          width: `${width}px`,
          height: `${h}px`,
          background,
          borderRadius: roundBorder ? `${width / 2}px` : undefined,
        }}
      />
    </div>
  );
};

IconWithAction.propTypes = {
  BackgroundIcon: PropTypes.elementType.isRequired,
  ForegroundIcon: PropTypes.elementType.isRequired,
  top: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  background: PropTypes.string,
  style: PropTypes.shape({}),
  roundBorder: PropTypes.bool,
};

IconWithAction.defaultProps = {
  top: undefined,
  bottom: undefined,
  left: undefined,
  right: undefined,
  width: 18,
  height: undefined,
  background: 'white',
  style: undefined,
  roundBorder: true,
};

const MemoizedIconWithAction = React.memo(IconWithAction);

const iconWithAction = (props) => {
  const Comp = () => <MemoizedIconWithAction {...props} />;
  Comp.muiName = 'SvgIcon';
  return Comp;
};

export { iconWithAction as default, MemoizedIconWithAction as IconWithAction };
